
import { Store, Hotel, Truck, ShoppingBag, Image, Calendar, Route } from "lucide-react";
import MyHomeLayout from "../MY_COMPONENTS/MyHomeLayout";
import { useAuth } from "../context/AuthContext";
import GazetteAnnouncementsPage from "@/SCRAPER/GazetteAnnouncements";
import { FaClock } from "react-icons/fa";
import { FaLeaf } from "react-icons/fa6";



export default function Templates() {
  const {user} = useAuth();


  const isSuperAdmin = (): boolean => {
    return user?.is_superadmin || false;
  };


  const apps = [
 {
    key: "hotelfront",
    title: "Hotel Front",
    description: "Hotel Front Page",
    icon: <ShoppingBag size={28} />,
    href: "/templates/hotelfront",
    enabled: true,
  //   component: <div className="flex flex-col w-full justify-between items-start">
  //   {user&&<MyDialogButton textButton label="My Listings" dialogContent={<MyOrders />} dialogHeader={<MyHeaderLabel label="MY ENTITIES"/>}/>}
  //   {isSuperAdmin()&& <>
  //  </>
  //   }
  //   </div>,
  },
   {
    key: "islandfront",
    title: "Island Front",
    description: "Island Front Page",
    icon: <ShoppingBag size={28} />,
    href: "/templates/islandfront",
    enabled: true,
  },
   {
    key: "iulaanfront",
    title: "Iulaan Front",
    description: "Iulaan Front Page",
    icon: <ShoppingBag size={28} />,
    href: "/templates/iulaanfront",
    enabled: true,
  },
   {
    key: "shopfront",
    title: "Shop Front",
    description: "Shop Front Page",
    icon: <ShoppingBag size={28} />,
    href: "/templates/shopfront",
    enabled: true,
  },
   {
    key: "routefront",
    title: "Route Front",
    description: "Route Front Page",
    icon: <Route size={28} />,
    href: "/templates/routefront",
    enabled: true,
  },
   {
    key: "quranquiz",
    title: "Quran Quiz",
    description: "quranquiz",
    icon: <Route size={28} />,
    href: "/templates/quranquiz",
    enabled: true,
  },
   {
    key: "quizapp",
    title: "Quiz App",
    description: "quiz app",
    icon: <Route size={28} />,
    href: "/templates/quizapp",
    enabled: true,
  },
   {
    key: "myapp",
    title: "My App",
    description: "my app",
    icon: <Route size={28} />,
    href: "/templates/myapp",
    enabled: true,
  },



 {
    key: "clock",
    title: "Clock",
    description: "learn time",
    icon: <FaClock size={28} />,
    href: "/clock",
    enabled: true,
   
  },
 {
    key: "quiz",
    title: "Quiz",
    description: "learn time",
    icon: <FaLeaf size={28} />,
    href: "/quiz",
    enabled: true,
   
  },


  {
    key: "admineroomcalendarpage",
    title: "Room Calendar",
    description: "Browse & manage media",
    icon: <Calendar size={28} />,
    href: "/admineroomcalendarpage",
    enabled: true,
  },
  {
    key: "imageconverter",
    title: "Image Converter",
    description: "Image Converter",
    icon: <Image size={28} />,
    href: "/imageconverter",
    enabled: true,
  },

];

  return (
    <MyHomeLayout apps={apps} headerText="Templates"/>
  );
}
